import { ToastConfig } from '@ngneat/hot-toast';

export const TOAST_GLOBAL_CONFIG: Partial<ToastConfig> = {
  position: 'top-right',
  dismissible: true,
  reverseOrder: true,
  duration: 5000,
};
